import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/698036f9921dc90014f2b02b/norcal_it_services/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/698036f9921dc90014f2b02b/norcal_it_services/src/app/homepage/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/698036f9921dc90014f2b02b/norcal_it_services/src/app/homepage/components/StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/698036f9921dc90014f2b02b/norcal_it_services/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/698036f9921dc90014f2b02b/norcal_it_services/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/698036f9921dc90014f2b02b/norcal_it_services/src/components/ui/AppImage.tsx");
